import { useDatabaseContent } from '@databases/database-state';
import { getService } from '@databases/service-container';
import { useEffect } from 'react';

import { useIsBulkEdit } from '../bulk-edit-context';

export interface PopoverSoftSelectionProps {
  entryId: string | undefined;
  fieldId: string;
  isRenderedInSidePanel: boolean | undefined;
  clearExistingSelection?: boolean;
}

export const usePopoverSoftSelection = ({
  entryId,
  fieldId,
  isRenderedInSidePanel,
  clearExistingSelection = false
}: PopoverSoftSelectionProps) => {
  const selectionsActions = getService('SelectionsActions');
  const { contentId } = useDatabaseContent();
  const isBulkEdit = useIsBulkEdit();

  useEffect(() => {
    // No need to set softSelection if popover is rendered in side panel
    if (!isBulkEdit && !isRenderedInSidePanel && entryId && contentId) {
      selectionsActions.selectValues([{ entryId, fieldId }], {
        clear: clearExistingSelection
      });
    }
  }, [
    selectionsActions,
    entryId,
    fieldId,
    clearExistingSelection,
    isRenderedInSidePanel,
    contentId,
    isBulkEdit
  ]);
};
